import React from 'react';
import { Button } from '@rentacenter/racstrap';

import { getStoreActionMessage } from './storeActionLocalization';

type StoreActionPaginationProps = {
  readonly className?: string;
  readonly hasNextPage: boolean;
  readonly isFetchingNextPage: boolean;
  readonly isRefetching: boolean;
  readonly onLoadMore: () => void;
};

export const StoreActionPagination: React.FC<StoreActionPaginationProps> = ({
  className,
  hasNextPage,
  isFetchingNextPage,
  isRefetching,
  onLoadMore,
}) => {
  if (!hasNextPage) {
    return null;
  }

  if (isRefetching) {
    return (
      <p className={className} role="status">
        {getStoreActionMessage('refreshingItems')}
      </p>
    );
  }

  return (
    <Button
      aria-busy={isFetchingNextPage || undefined}
      className={className}
      disabled={isFetchingNextPage}
      onClick={onLoadMore}
      type="button"
    >
      {getStoreActionMessage(isFetchingNextPage ? 'loadingMore' : 'loadMore')}
    </Button>
  );
};
